import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {getPowerSourceLocationsData, IPowerSource, IPowerSourceLocation} from "../../../../data/data";
import {getDraggingOrigin, getDraggingPowerSource, Point} from "../../../../store/reducers/draggingPowerSource";
import {getMapOffset} from "../../../../store/reducers/map/mapOffset";
import {setHighlightLocation} from "../../../../store/actions/locations";
import {placePowerSource} from "../../../../store/actions/powerSources";
import {getMapBounds, Rect} from '../../../../store/reducers/map/mapBounds';

interface Props extends IPowerSource
{
    power_source: IPowerSource;
    origin: Point;
    map_bounds: Rect;
    map_offset: Point;
    setHighlightLocation: (location_id: number) => void;
    placePowerSource: () => void;
}

interface State
{
    dragging: boolean;
    style_name: string;
    x: number;
    y: number;
}

import './DraggablePowerSource.scss';

class DraggablePowerSource extends React.Component<Props, State>
{
    constructor(public props: Props, public state: State)
    {
        super(props);

        this.state =
            {
                dragging: false,
                style_name: 'hidden',
                x: 0, y: 0
            };
    }


    componentDidUpdate(prev_props: Props, prev_state: State)
    {
        const {power_source:npower_source} = this.props;
        const {power_source:opower_source} = prev_props;
        const {power_source} = this.props;
        const {dragging:ndragging} = this.state;
        const {dragging:odragging} = prev_state;

        //  when we have a power source

        if (npower_source && ! opower_source) return this.startDragging();

        // if (! ndragging && odragging) return this.stopDragging();

        // if (power_source && ! dragging) return this.startDragging();
        //
        // if (! dragging) return this.stopDragging();
    }


    setStartPosition = (el: HTMLElement) =>
    {
        const {origin} = this.props;
        const {x, y} = origin;

        this.setState({x, y});
    };


    startDragging = () =>
    {
        const {dragging} = this.state;

        if (dragging) return;

        //  add mouse listeners

        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.stopDragging);

        this.setState({ dragging: true, style_name: 'dragging' });
    };


    stopDragging = () =>
    {
        const {placePowerSource} = this.props;

        //  remove mouse listeners

        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDragging);

        placePowerSource();

        //  are we over a valid location?
        //  if so, place the new power source;
        //  if not, clear the dragging source

        this.setState({ dragging: false, style_name: 'hidden' });
    };


    onDrag = (event: MouseEvent) =>
    {
        const {map_offset, setHighlightLocation} = this.props;
        const {x:ox, y: oy} = map_offset;
        const {pageX:mx, pageY:my} = event;
        const x: number = mx - ox;
        const y: number = my - oy;

        const {map_bounds} = this.props;

        // console.log(map_bounds);

        const pcx: number = Math.round(x / map_bounds.width / 0.01);
        const pcy: number = Math.round(y / map_bounds.height / 0.01);

        const radius: number = 0.5;

        //  test power source position against the position of map locations;
        //  if we're near a location, test its type;
        //  TODO if it's free, let's do some sort of glowy indicator
        //  TODO if it's not free, indicate that too

        const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();

        const location_id: number = _.findIndex(locations, location =>
        {
            const {position} = location;
            const [px, py] = position;
            const x1: number = px - radius;
            const x2: number = px + radius;
            const y1: number = py - radius;
            const y2: number = py + radius;

            return pcx > x1 && pcx < x2 && pcy > y1 && pcy < y2;
        });


        // console.group('dragging');
        // console.log('location_id', location_id);
        // console.groupEnd();

        setHighlightLocation(location_id);

        this.setState({x: mx, y: my});
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {power_source} = this.props;
        const {style_name, x, y} = this.state;

        if (! power_source) return null;

        const {id} = power_source;

        return <div
                    styleName={style_name}
                    style={{ top: y, left: x }}
                    ref={this.setStartPosition}>

            <span
                styleName={'image'}
                style={{ backgroundImage: `url(./img/game/map-power-sources/${id}@2x.png)` }} />

        </div>;

        // return <div
        //             styleName={'dragging'}
        //             style={{ top: 50, left: 50 }}>
        //
        //     <span styleName={'image'} />
        //
        //     {/*<img*/}
        //         {/*styleName={'image'}*/}
        //         {/*src={`./img/game/map-power-sources/gas@2x.png`} />*/}
        //
        // </div>
    }
}


const mapStateToProps = (state, props) =>
{
    return {
        power_source: getDraggingPowerSource(state),
        origin: getDraggingOrigin(state),
        map_bounds: getMapBounds(state),
        map_offset: getMapOffset(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        setHighlightLocation: (location_id: number) => dispatch(setHighlightLocation(location_id)),
        placePowerSource: () => dispatch(placePowerSource())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DraggablePowerSource);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/power-sources/DraggablePowerSource.tsx